// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__UhpG7","image":"NotFound_image__ENQEn"};